<template>
  <div class="common-detail-left-view" :class="{'fixed-btn': fixedBtn}" >
    <div v-for="(group, index) in config.group" :key="index" class="group-item" :style="group.style || {}">
      <template v-if="!group.hide">
        <div v-if="group.label" class="group-title" @click="handleTitle(group)">
          {{group.label}}
          <span class="right">
            <span class="desc">{{group.desc}}</span>
            <i v-if="group.open" class="icon el-icon-arrow-up" :class="{'icon-open': group.open === 1}" />
          </span>
        </div>
        <div class="group-content" ref="content" :style="group.style || {}">
          <div v-if="group.column" class="content-box" :class="{hide: group.open === 2}" :style="getHideHeight(group)">
            <template v-for="(item, index) in group.column">
              <div v-if="item.display !== false" :key="item.prop || index" class="form-item" :style="{...getItemStyle(item), ...item.itemStyle}">
                <span class="label" v-if="item.label" :class="{required: item.required || item.rules && item.rules.find(o=>o.required)}"
                  :style="item.labelStyle||{}">{{item.label}}:</span>
                <span class="input-box" :class="{'is-error': !!errorObj[item.prop]}" :style="item.boxStyle||{}">
                  <template v-if="$slots[item.prop] || item.slot === true">
                    <slot :name="item.prop" />
                  </template>
                  <template v-else>
                    <el-input type="textarea" v-if="item.type === 'textarea'" :value="value[item.prop]" @input="handleInput(item, $event)"
                      @blur="handleBlur(item, value[item.prop])" :maxlength="item.maxlength || 500" :rows="item.minRows || 4" show-word-limit
                      :placeholder="item.placeholder" :disabled="item.disabled" clearable @clear="handleBlur(item, '')" />
                    <el-select v-else-if="item.type === 'select'" :value="value[item.prop]" @change="handleInput(item, $event)"
                      :disabled="item.disabled" :clearable="item.clearable">
                      <el-option v-for="option in item.dicData" :key="option[item.props ? item.props.value : 'value']"
                        :label="option[item.props ? item.props.label : 'label']" :value="option[item.props ? item.props.value : 'value']" />
                    </el-select>
                    <span v-else-if="item.type === 'navText'" class="link-view" @click="handleWaybillNo(value['recordId'])">{{value[item.prop]}}</span>
                    <el-input v-else :value="value[item.prop]" @input="handleInput(item, $event)" @blur="handleBlur(item, value[item.prop])"
                      :placeholder="item.placeholder" :disabled="item.disabled" :style="{width: item.valueWidth || '100%'}" clearable
                      @clear="handleBlur(item, '')" :maxlength="item.maxlength || 100" />
                  </template>
                  <div class="error-label">{{errorObj[item.prop]}}</div>
                </span>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <div class="btn-view" v-if="!hidden" :class="{'fixed-btn': fixedBtn}" :style="{width: fixedBtn}">
      <slot name="btnSlot" />
      <el-button v-if="!option.saveHide" type="primary" :loading="loading" :disabled="loading" @click="handleSave">{{option.saveText || $lang('保存')}}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {},
      errorObj: {},
      loading: false
    }
  },
  props: {
    option: Object,
    value: Object,
    fixedBtn: String,
    hidden: Boolean
  },
  computed: {
    labelWidth() {
      return this.option.labelWidth || 220
    }
  },
  watch: {
    option(option) {
      this.setConfig(option)
    }
  },
  created() {
    this.setConfig()
  },
  methods: {
    handleWaybillNo(recordId) {
      console.log(recordId)
      // const { id } = this.$route.params
      // console.log(id)
      this.$router.push({
        name: 'searchQualityRecord',
        query: {
          id: recordId
        }
      })
    },
    setConfig() {
      if (this.option.group) {
        this.config = this.option
      } else {
        this.config = {
          group: [
            { ...this.option }
          ]
        }
      }
    },
    handleTitle(group) {
      if (group.open) {
        group.open = group.open === 2 ? 1 : 2
      }
    },
    getItemStyle(item) {
      const css = {}
      if (item.span) {
        css.width = this.labelWidth * item.span + 'px'
      } else if (item.span === 0) {
        css.width = '100%'
      } else {
        css.width = this.labelWidth + 'px'
      }
      return css
    },
    getHideHeight(item) {
      if (item.hideHeight) {
        return {
          marginTop: item.open === 2 ? item.hideHeight : '0%'
        }
      }
      return {}
    },
    handleInput(item, val) {
      const data = { ...this.value }
      data[item.prop] = val
      this.$emit('input', data)
      if (typeof item.change === 'function') {
        item.change(val)
      }
      this.handleRule(item, val, 'input')
    },
    handleBlur(item, val) {
      const data = { ...this.value }
      data[item.prop] = val
      this.handleRule(item, val, 'blur')
    },
    handleRule(item, val = '', type) {
      if (!item) {
        return
      }
      this.errorObj[item.prop] = ''
      if (item.rules && item.rules.length) {
        item.rules.map(rule => {
          if (~rule.trigger.indexOf(type)) {
            if (rule.validator && typeof rule.validator === 'function') {
              // 不确定回传rule 是什么 {}
              rule.validator({}, val, err => {
                if (err) {
                  this.errorObj = {
                    ...this.errorObj,
                    [item.prop]: err.toString().replace('Error: ', '')
                  }
                }
              })
            }
            let required = ''
            if (val !== null && val.constructor === String) {
              required = !val.trim()
            } else if (val.constructor === Array) {
              required = val.length === 0
            } else {
              required = val === undefined || val === null
            }
            if (rule.required && required) {
              this.errorObj = {
                ...this.errorObj,
                [item.prop]: rule.message
              }
            }
            // 隐藏元素过滤
            if (!(item.display || item.display === undefined)) {
              this.errorObj[item.prop] = ''
            }
          }
        })
      }
      if (item.required && item.display !== false) {
        let required = ''
        if (val !== null && val.constructor === String) {
          required = !val.trim()
        } else if (val.constructor === Array) {
          required = val.length === 0
        } else {
          required = val === undefined || val === null
        }
        if (required) {
          this.errorObj = {
            ...this.errorObj,
            [item.prop]: this.$lang('请输入')
          }
        }
      }
    },
    validate(cb) {
      if (this.config.group) {
        this.config.group.map(o => {
          o.column &&
            o.column.map(item => {
              this.handleRule(item, this.value[item.prop], 'blur')
            })
        })
      }
      // this.option.column &&
      //   this.option.column.map(item => {
      //     this.handleRule(item, this.value[item.prop], 'blur')
      //   })

      console.log(this.errorObj)
      console.log(Object.values(this.errorObj))
      console.log(!Object.values(this.errorObj).filter(o => o).length)

      cb && cb(!Object.values(this.errorObj).filter(o => o).length)
    },
    validateField(prop, cb) {
      let item
      if (this.config.group) {
        this.config.group.map(o => {
          if (o.column) {
            item = item || o.column.find(item => item.prop === prop)
          }
        })
      }
      // if (this.option.column) {
      //   item = item || this.option.column.find(i => i.prop === prop)
      // }
      setTimeout(() => {
        this.handleRule(item, this.value[prop] || '', 'blur')
      }, 10)
      console.log('validateField', item)
    },
    resetFields() {
      this.errorObj = {}
    },
    resetForm() {
      console.log('resetForm')
    },
    handleSave() {
      this.$emit('beforeSubmit')
      this.validate(val => {
        if (val) {
          this.loading = true
          this.$emit('submit', () => {
            this.loading = false
          })
        }
      })
    },
    clearValidate() {
      console.log('clearValidate')
    }
  }
}
</script>

<style lang="scss" scoped>
.common-detail-left-view {
  &.fixed-btn{
    padding-bottom: 52px;
  }
  .group-item {
    margin-bottom: 10px;
    border: 1px solid #ddd;
    @include border-color('lighter');
    .group-title {
      font-size: 14px;
      line-height: 40px;
      color: #666;
      border-bottom: 1px solid #ddd;
      @include text-color('subtitle');
      @include border-color('lighter');
      @include bg-color('light');
      font-weight: 600;
      &::before {
        content: '';
        height: 12px;
        width: 2px;
        float: left;
        margin: 14px 0;
        margin-right: 10px;
        background-color: #666;
      }
      .right {
        float: right;
        font-size: 12px;
        font-weight: initial;
      }
      .icon {
        margin: 0 15px;
        transform: rotate(0);
        transition: 0.5s transform;
        &.icon-open {
          transform: rotate(180deg);
        }
      }
    }
    .group-content {
      margin-left: 20px;
      box-sizing: border-box;
      margin-bottom: -1px;
      overflow: hidden;

      .content-box {
        margin-top: 0%;
        transition: margin-top 0.5s;
        &.hide {
          margin-top: -100%;
        }
      }
    }
  }

  .form-item {
    box-sizing: border-box;
    float: left;
    padding-right: 20px;
    margin-top: 16px;
    align-items: center;
    &.block-item {
      width: 100%;
    }
    &:last-child {
      margin-bottom: 20px;
    }
    &:after {
      content: '';
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }
    .label {
      white-space: nowrap;
      line-height: 22px;
      display: block;
      &.required:before {
        content: '*';
        color: #f56c6c;
      }
    }
    .input-box {
      width: 100%;
      min-height: 24px;
      line-height: 24px;
      position: relative;
      display: inline-block;
    }
    .error-label {
      position: absolute;
      font-size: 12px;
      line-height: 16px;
      bottom: -16px;
      color: #f56c6c;
      white-space: nowrap;
    }
  }
  .btn-view {
    padding-top: 20px;
    padding-right: 20px;
    text-align: right;

    &.fixed-btn {
      position: fixed;
      bottom: 9px;
      padding: 10px 20px;
      box-sizing: border-box;
      @include bg-color('light');
    }
  }
}
</style>

<style lang="scss">
.link-view{
  @include base-color('clr');
}
.common-detail-left-view {
  .is-error {
    input,
    textarea {
      border: 1px solid #f56c6c;
    }
  }
  .el-radio__label {
    padding-left: 4px;
  }
  .el-select {
    display: block;
  }
  .el-textarea {
    textarea {
      resize: none;
      font-size: 14px;
      line-height: 16px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }
  .el-radio {
    margin-right: 10px !important;
  }
}
</style>
